import { Accessibility } from "./accessibility"
import { Account } from "./account"
import { User } from "./user"
import { Laverie } from "./laverie"
import { Product } from "./product"

export interface BonLivraison {
    account: Account
    laverie: Laverie
    products: Product[]
    deliveryDate?: Date
    accessibility: Accessibility
    contactSecond: User
    observations: string
    deliveredBy: User
}

export class BonLivraisonGen {
    // laverie.numeroDeContrat
    lnc: string

    // laverie.name
    ln: string

    // laverie.address.ville
    lav: string

    // laverie.address.numero
    lan: string

    // laverie.address.rue
    lar: string

    // laverie.address.codepostale
    lacp: string

    // products for the laverie
    lp: Product[]

    // accessibility.etage
    aet: string
    haet: boolean

    // accessibility.codePorte
    acp: string
    hacp: boolean

    // accessibility.key
    ak: string
    hak: boolean

    // accessibility.ascenseur
    aa: string
    haa: boolean

    // accessibility.escalier
    ae: string
    hae: boolean

    // accessibility.parking
    ap: string
    hap: boolean

    // laverie.gestionnaire
    cpn: string
    hcpn: boolean

    // laverie.gestionnaire (fonction)
    cpf: string
    hcpf: boolean

    // laverie.telephonePrincipal
    cpm: string
    hcpm: boolean

    // laverie.telephoneAutre
    cpt: string
    hcpt: boolean

    // contactSecond.name
    csn: string
    hcsn: boolean

    // contactSecond.fonction
    csf: string
    hcsf: boolean

    // contactSecond.telephone
    cst: string
    hcst: boolean

    // contactSecond.mobile
    csm: string
    hcsm: boolean

    // deliveredBy.name
    dbn: string
    hdbn: boolean

    // deliveredBy.lastname
    dbl: string
    hdbl: boolean

    // deliveryDate
    dd: Date

    // observations
    o: string
    ho: boolean
}

export function flattenBonLivraison(input: BonLivraison): BonLivraisonGen {
    const b = new BonLivraisonGen();
    if (input.laverie) {
        b.ln = input.laverie.name
        b.lnc = input.laverie.numeroDeContrat.toString()
        b.lan = input.laverie.address.numero
        b.lar = input.laverie.address.rue
        b.lav = input.laverie.address.ville
        b.lacp = input.laverie.address.codepostale
        b.lp = input.products
    }
    if (input.laverie && input.laverie.codeAcces) {
        b.acp = input.laverie.codeAcces
        b.hacp = true
    } else {
        b.hacp = false
    }
    if (input.accessibility) {
        if (input.accessibility.etage) {
            b.aet = input.accessibility.etage
            b.haet = true
        } else {
            b.haet = false
        }
        if (input.accessibility.key) {
            b.ak = input.accessibility.key
            b.hak = true
        } else {
            b.hak = false
        }
        if (input.accessibility.ascenseur) {
            b.aa = input.accessibility.ascenseur
            b.haa = true
        } else {
            b.haa = false
        }
        if (input.accessibility.escalier) {
            b.ae = input.accessibility.escalier
            b.hae = true
        } else {
            b.hae = false
        }
        if (input.accessibility.parking) {
            b.ap = input.accessibility.parking
            b.hap = true
        } else {
            b.hap = false
        }
    }

    if (input.laverie && input.laverie.gestionnaire) {
        b.cpn = input.laverie.gestionnaire
        b.hcpn = true
    } else {
        b.hcpn = false
    }
    b.cpf = "Gestionnaire"
    b.hcpf = true

    if (input.laverie && input.laverie.telephoneAutre) {
        b.cpt = input.laverie.telephoneAutre
        b.hcpt = true
    } else {
        b.hcpt = false
    }
    if (input.laverie && input.laverie.telephonePrincipal) {
        b.cpm = input.laverie.telephonePrincipal
        b.hcpm = true
    } else {
        b.hcpm = false
    }

    if (input.contactSecond) {
        if (input.contactSecond.name) {
            b.csn = input.contactSecond.name
            b.hcsn = true
        } else {
            b.hcsn = false
        } if (input.contactSecond.fonction) {
            b.csf = input.contactSecond.fonction
            b.hcsf = true
        } else {
            b.hcsf = false
        }
        if (input.contactSecond.telephone) {
            b.cst = input.contactSecond.telephone
            b.hcst = true
        } else {
            b.hcst = false
        }
        if (input.contactSecond.mobile) {
            b.csm = input.contactSecond.mobile
            b.hcsm = true
        } else {
            b.hcsm = false
        }
    }
    if (input.deliveredBy) {
        if (input.deliveredBy.name) {
            b.dbn = input.deliveredBy.name
            b.hdbn = true
        } else {
            b.hdbn = false
        }
        if (input.deliveredBy.lastname) {
            b.dbl = input.deliveredBy.lastname
            b.hdbl = true
        } else {
            b.hdbl = false
        }
    }
    b.dd = input.deliveryDate
    if (input.observations) {
        b.o = input.observations
        b.ho = true
    } else {
        b.ho = false
    }
    return b;
}